<template>
  <section class="tags">
    <div
      v-for="(tag, tagIndex) in dataSource"
      :key="tagIndex"
      class="tag-container"
    >
      <router-link
        :to="{ name: 'tag', params: { tagId: tag.id } }"
        :title="`[前往]有${tag.name}標籤的導覽`"
        :style="`background-color: ${
          tag.tagGroupInfo ? tag.tagGroupInfo.color : '#ecc969'
        }`"
        class="tag"
        >{{ tag.name }}</router-link
      >
    </div>
  </section>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dataSource() {
      const dataSource = [...this.tags]
      dataSource.sort((a, b) => {
        if (a.tagGroupInfo && b.tagGroupInfo) {
          return a.tagGroupInfo.priority - b.tagGroupInfo.priority
        }
      })
      return dataSource
    }
  }
}
</script>
<style lang="scss" scoped>
.tags {
  margin-bottom: 40px;
  max-width: 280px;
  margin-left: auto;
  margin-right: auto;
  @include for-tablet {
    max-width: 100%;
  }
  @include for-desktop {
    margin-bottom: 0px;
  }
}
.tag-container {
  + .tag-container {
    margin-top: 10px;
  }
}

.tag {
  box-sizing: border-box;
  color: $color-tag-text;
  padding: 0px 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 54px;
  border-radius: 8px;
  min-width: 120px;
  font-family: $text-font-family;
  font-size: 1.125rem;
  letter-spacing: 0.9px;
}
</style>
